const MAX_FILE_SIZE_IN_BYTE = 26214400;
export default MAX_FILE_SIZE_IN_BYTE;
